import { useSyncExternalStore } from 'react'

// Ключи экспериментов
export type ExperimentKey = 'driver_recharge_growth' | 'driver_recharge_ui'

// Состояние экспериментов
type ExperimentState = {
    isReady: boolean
    variants: Record<ExperimentKey, 'A' | 'B' | 'C' | 'control'>
}

// Начальное состояние экспериментов
let state: ExperimentState = {
    isReady: false,
    variants: {
        driver_recharge_growth: 'control',
        driver_recharge_ui: 'control',
    },
}

// Набор слушателей для уведомлений о изменениях состояния экспериментов
const listeners = new Set<() => void>()

// Получение текущего состояния экспериментов
const getSnapshot = (): ExperimentState => state

// Подписка на изменения состояния экспериментов
const subscribe = (listener: () => void): (() => void) => {
    listeners.add(listener)

    return () => {
        listeners.delete(listener)
    }
}

// Установка состояния экспериментов
const setState = (nextState: ExperimentState): void => {
    state = nextState
    for (const listener of listeners) {
        listener()
    }
}

// Загрузка конфига при старте
export function loadExperiments(
    experiments: Record<ExperimentKey, 'A' | 'B' | 'C' | 'control'>,
): void {
    setState({
        isReady: true,
        variants: experiments,
    })
}

// Хук для проверки готовности экспериментов
export function useExperimentsReady(): boolean {
    const snapshot = useSyncExternalStore(subscribe, getSnapshot)

    return snapshot.isReady
}

// Хук для чтения варианта эксперимента
export function useExperiment(
    key: ExperimentKey,
    fallback: 'A' | 'B' | 'C' | 'control' = 'control',
) {
    const snapshot = useSyncExternalStore(subscribe, getSnapshot)

    if (!snapshot.isReady) {
        return fallback
    }

    return snapshot.variants[key] ?? fallback
}
